const ZONE_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[zoneManagementExperience] createZone',
  SET_CREATED: '[zoneManagementExperience] setCreated',
  EDIT: '[zoneManagementExperience] editZone',
  DELETE: '[zoneManagementExperience] deleteZone'
}

export default ZONE_MANAGEMENT_EXPERIENCE_TYPES
